import { useEffect, useSyncExternalStore } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import UbiquaTowerToastAlert from './alerts/UbiquaTowerToastAlert'
import {
  clearDeniedDetailPath,
  DETAIL_ACCESS_MESSAGE,
  DETAIL_ACCESS_TITLE,
  dismissDetailAccess,
  getDetailAccess,
  subscribeDetailAccess
} from '../auth/detailAccess'

export default function DetailAccessGuard({ children }) {
  const location = useLocation()
  const notice = useSyncExternalStore(subscribeDetailAccess, getDetailAccess)
  const denied = notice?.path === `${location.pathname}${location.search}`

  useEffect(() => {
    if (notice?.path && !denied) clearDeniedDetailPath()
  }, [notice, denied])

  return (
    <>
      {denied ? <Navigate to="/inicio" replace /> : children}
      {notice && (
        <UbiquaTowerToastAlert
          id={`detail-access-${notice.id}`}
          severity="error"
          title={DETAIL_ACCESS_TITLE}
          message={DETAIL_ACCESS_MESSAGE}
          durationMs={6000}
          onClose={dismissDetailAccess}
        />
      )}
    </>
  )
}
